//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { mapGetters } from 'vuex'

export default {
  name: 'SingleMobileTable',
  props: {
    coin: {
      type: Object,
      default: null
    },
    currencyType: {
      type: String,
      default: null
    }
  },
  computed: {
    isTether () {
      return !!this.coin && (String(this.coin.symbol).toUpperCase() === 'USDT' || String(this.coin.slug).toLowerCase() === 'tether')
    },
    ...mapGetters({
      getSymbolFaName: 'coins/getSymbolFaName',
      buyDollarPrice: 'coins/buyDollarPrice',
      assets: 'coins/assets',
      watchList: 'watchList/watchList',
      isGuest: 'auth/isGuest'
    })
  },
  methods: {
    open () {
      this.$refs.mySheet.open()
    },
    addWatchList (coin) {
      if (this.isGuest) {
        const router = this.$router.resolve({ path: '/my/auth/login' })
        window.open(router.href)
      } else {
        this.$store.dispatch('watchList/addFavorite', coin)
      }
    }
  }
}
